import {DocumentNode, gql} from '@apollo/client';

import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

export const GET_SCRATCH_FILE_QUERY: DocumentNode = gql`
  query GetScratchFile($id: StrictString!) @skipAudit @engComponent(name: PIPELINES) {
    scratchFile(id: $id) {
      ...ScratchFileGraphQL
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('ScratchFile').fragment}
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;
